/**
 * Interface wording for this app.
 *
 * The dictionary is not bundled. WordPress prints it as window.CabinaI18n
 * before the app loads, so a correction to the Arabic is a re-import and a
 * refresh rather than a rebuild of three React apps - and corrections arrive
 * in waves once a client starts reviewing.
 *
 * Anything missing falls back to the English it was given, so a partly filled
 * dictionary is safe to ship and an untranslated string is visible rather than
 * blank.
 */
const dictionary = () => (typeof window !== 'undefined' && window.CabinaI18n) || null;

/**
 * Translate a piece of interface text.
 *
 * @param {string} english The English string, which doubles as the key.
 * @returns {string}
 */
export const t = (english) => {
	const source = dictionary();

	if (!source || !source.strings) {
		return english;
	}

	const translated = source.strings[english];

	return typeof translated === 'string' && translated !== '' ? translated : english;
};

/** The language the page is being served in. */
export const lang = () => {
	const source = dictionary();
	return source && source.lang ? source.lang : 'en';
};

/*
 * Whether the current language composes phrases Arabic-style.
 *
 * This is about word order, not layout. The configurators stay left to right
 * in Arabic - the panels, the 3D view and the controls keep their positions -
 * but a phrase like "U-Shape Wardrobe" still has to lead with the noun. Naming
 * it isRtl invited exactly the wrong conclusion.
 */
export const isArabic = () => lang() === 'ar';
